<template>
  <div style="padding-top: 28vh;">

    <div v-if="allowedState.length && show"
      class="state-menu col-md-12 mb-1"
      :style="stateMenuStyles"
    >
      <nav
        class="navbar navbar-expand navbar-light bg-light"
        style="padding: 0"
        :style="getNavbarStyles()"
      >
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-3 mr-auto mt-3 mt-lg-0">
            <li class="nav-item" v-for="st in this.allowedState" :key="st">
              <a
                class="nav-link"
                style="padding-left: 0.38rem; padding-right: 0.38rem;"
                :class="{ active: activeState === st }"
                :style="getStateSelectionRolldStyles(activeState === st)"
                @click.prevent="filterStore(st)"
                href="#"
                >{{ st == "All" ? $t("message.all") : st }}</a
              >
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div
      v-if="show"
      class="mobile-resturants container"
      :style="restaurantsContainerStyles"
    >
      <div
        v-for="rs in orderedResturants"
        :key="rs.ID"
        class="row"
        @click="navigateToStore(rs)"
      >
        <div class="triangle-container"  v-if="storeClosed(rs)">
          <div
            class="triangle-topright-img"
          >
            <span>
              {{ $t("message.closed") }}
            </span>
          </div>
        </div>
        <div class="item">
          <div
            v-if="rs.ProfileImage"
            class="item-img"
            :style="{ 'background-image': 'url(' + rs.ProfileImage + ')' }"
          ></div>
          <div class="item-details with-image">
            <h2 class="item-title rolld-primary-color">{{ getStoreTitle(rs) }}</h2>
<!--            <p class="item-subtitle">{{ rs.StoreTitle }}</p>-->
            <p class="item-subtitle">
              {{ rs.Location.Address }}
              <br />
              {{ rs.Location.Suburb }} {{ rs.Location.State }} {{ rs.Location.Postcode }}
            </p>
          </div>
          <h2 class="item-hours">
            <div
              v-if="getOperatingHours(rs)"
              :class="{'color-gray': !isRolldStore()}"
            >
              {{ $t("message.open") }}
              <span>{{ getOperatingHours(rs).openTime }}</span>
              {{ $t("message.toName") }}
              <span>{{ getOperatingHours(rs).closeTime }}</span>
            </div>
          </h2>
          <span v-if="pos" class="item-loc">
            <span class="material-icons">near_me</span>
            {{ distance(rs.Location.Latitude, rs.Location.Longitude) }}km
            {{ $t("message.away") }}
          </span>
        </div>
      </div>
    </div>
    <div v-else>
      <message :message="getNoStoreAvailableInDatabaseLang" v-show="!busy" />
      <progressindicator
        v-show="busy"
        style="opacity: 0.4;"
      ></progressindicator>
    </div>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/master/Resturant/ResturantsFilter.js";
import Progressindicator from "../../progressindicator";
import Message from "../../shared/Message";
import {mapGetters} from "vuex";

export default {
  components: { Progressindicator, Message },
  filters: {
    ...shared.filters,
  },
  props: {
    filterQuery: {
      type: String,
      default: "all",
    },
    activeState: {
      type: String,
      default: "All",
    },
  },
  data() {
    return {
      populars: [],
      pos: null,
      busy: false,
      states: ["All", "ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"],
    };
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["viewConfig"]),
    hasLogo() {
      if (this.isRolldStore()) {
        return this.hqDoc ? this.hqDoc.Logo : null;
      }
      return null;
    },
    stateMenuStyles() {
      return this.hasLogo ? 'padding-top: 100px' : 'padding-top: 0';
    },
    restaurantsContainerStyles() {
      let space = this.hasLogo && this.allowedState.length > 2 ?
        100 :
        this.hasLogo ?
        40 :
        0;
      return `margin-top: ${space}${space ? 'px' : ''}`;
    },
    showNewUi(){
      return this.viewConfig.IsNewUI
    }
  },
  watch: {
    filterQuery(newValue) {
      this.populars = [];
      if (newValue === "all") {
        this.getStores();
      } else {
        this.getnearStores();
      }
    },
  },
  created() {
    this.checkLocation();
    this.getStores();
  },
  methods: {
    ...shared.methods,
    getStateSelectionRolldStyles(isSelected) {
      var styles = [];
      if (this.isRolldStore()) {
        if (isSelected) styles.push(this.mobileStyles.MenuHighlightedText);
        else styles.push(this.mobileStyles.textColour);
      }
      return styles;
    },

    getStoreTitle(store){
      if(!store) return ""
      return store.StoreTitle ? store.StoreTitle : store.Name
    }
  },
};
</script>
